import { MutableRefObject } from 'react';
import { DataGrid as MuiDataGrid, DataGridProps as MuiDataGridProps } from '@mui/x-data-grid';
import { GridApiCommunity } from '@mui/x-data-grid/internals';

import { useDataGrid } from './DataGridContext';
import { DEFAULT_PAGE_SIZE_OPTIONS, DEFAULT_SLOT_PROPS } from './DataGrid.const';

interface DataGridComponentProps<T> extends MuiDataGridProps {
  dataTestId?: string;
  apiRef: MutableRefObject<GridApiCommunity>;
}

export const DataGridComponent = <T,>({
  apiRef,
  dataTestId = 'data-grid',
  editMode = 'row',
  pagination = true,
  slotProps = DEFAULT_SLOT_PROPS,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  ...props
}: DataGridComponentProps<T>) => {
  const { rows, rowCount, loading, paginationModel, onPaginationModelChange } = useDataGrid();

  return (
    <MuiDataGrid
      apiRef={apiRef}
      disableRowSelectionOnClick
      data-testid={dataTestId}
      editMode={editMode}
      pagination={pagination}
      slotProps={slotProps}
      pageSizeOptions={pageSizeOptions}
      paginationModel={paginationModel}
      onPaginationModelChange={onPaginationModelChange}
      paginationMode="server"
      rows={rows}
      rowCount={rowCount}
      loading={loading}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 3,
        backgroundColor: 'background.paper',
        '& .MuiDataGrid-columnHeaders': {
          '& .MuiSvgIcon-root': {
            color: 'primary.contrastText',
          },
          '& .MuiDataGrid-filler': {
            backgroundColor: 'primary.main',
          },
        },
        '& .MuiDataGrid-columnHeader, & .MuiDataGrid-scrollbarFiller': {
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
        },
        ...props.sx,
      }}
      {...props}
    />
  );
};
